import { useQuery } from '@tanstack/react-query';
import { getBrands } from '../utils/api';
import { Link } from 'react-router-dom';

export default function Brands(){
  const { data } = useQuery({ queryKey:['brands'], queryFn:getBrands });
  return (<main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
    <h1 className="text-2xl font-bold">Brands</h1>
    <ul className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
      {(data||[]).map(b=>(<li key={b.slug}><Link to={`/brand/${b.slug}`} className="block rounded-xl border border-slate-200 bg-white p-4 hover:shadow">{b.name}</Link></li>))}
    </ul>
  </main>);
}
